import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import styled, { css } from 'styled-components'

import { breakpoints, colors } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'

import { Card, Description, Text } from './elements'
import paymentImageMobile from './images/payment-mobile@3x.png'
import paymentImage from './images/payment@3x.png'

const PaymentsCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

const Mini = styled(Description)`
  margin-left: 5px;
  font-size: 14px;
  font-weight: 400;
  font-style: italic;
  color: ${colors.mediumGrey};
  letter-spacing: -0.2px;
  line-height: 19px;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Options = styled.div`
  display: flex;
  flex-direction: column;
`

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 415px;

  @media (max-width: ${breakpoints.tabletLandscape}) {
    height: 370px;
  }
`

const descriptionStyles = css`
  display: flex;
  align-items: center;
`

const PaymentOptions = () => {
  const { t } = useTranslation('renters')
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.phoneMax})`)

  return (
    <PaymentsCard>
      <TextWrapper>
        <Text>{t('renters:Pay for rent however you want, including')}:</Text>
        <Options>
          <Description>- {t('renters:Credit card')}</Description>
          <Description>- {t('renters:UnionPay')}</Description>
          <Description>- {t('renters:Bitcoin')}</Description>
          <Description customStyle={descriptionStyles}>
            - {t('renters:PAD')}
            <Mini>{`(${t('renters:coming soon')})`}</Mini>
          </Description>
        </Options>
      </TextWrapper>
      <ImageWrapper>
        <Image
          src={displayMobile ? paymentImageMobile : paymentImage}
          alt="Payment options"
          sizes="440px"
          layout="fill"
          objectFit="contain"
          placeholder="blur"
        />
      </ImageWrapper>
    </PaymentsCard>
  )
}

export default PaymentOptions
